module.exports = __webpack_public_path__ + "static/fighter-02-536c9ed01fb0b12b514cd218c9e9e440.png";